import { render, staticRenderFns } from "./LandPlace.vue?vue&type=template&id=4c8b8ea0&scoped=true"
import script from "./LandPlace.vue?vue&type=script&lang=js"
export * from "./LandPlace.vue?vue&type=script&lang=js"
import style0 from "./LandPlace.vue?vue&type=style&index=0&id=4c8b8ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b8ea0",
  null
  
)

export default component.exports